import type { ReactNode } from "react";

export function SessionEnded({
  expired = false,
  onLeave,
}: {
  expired?: boolean;
  onLeave?: () => void;
}): ReactNode {
  return (
    <main className="centered-page">
      <section className="surface stack" role="status">
        <p className="eyebrow">Session ended</p>
        <h1 tabIndex={-1} autoFocus>
          {expired ? "This room has expired" : "The host ended this game"}
        </h1>
        <p>{expired ? "Expired rooms cannot be recovered." : "No winner was declared."}</p>
        {onLeave ? (
          <button type="button" onClick={onLeave}>
            Return home
          </button>
        ) : null}
      </section>
    </main>
  );
}
